import { gql } from 'apollo-angular';

export const getAggregation = gql`
  query getAggregation($request: AggregationRequest!) {
    elementTypeAggregations(request: $request) {
      fieldUri
      aggregations {
        aggregationType
        aggregationValue
      }
    }
  }
`;
